// extracted by mini-css-extract-plugin
module.exports = {"container":"FyeN01I48fkxGZy6EAqGq","additionalList":"_35yFSluUApiLV9KjuXGD1y","item":"iCiBn2E6ZG5nzHYxzGcuJ","dot":"_3X57U1iQe6tGVYGUjyJG5X","externalId":"WVdSAMF44bLN7UEFEvTJL"};